import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect,
  Switch
} from "react-router-dom";

import { isLoggedIn, getAccessToken } from './AuthService';
import Home from './Home';


class App extends Component {
  render() {
    return (
      <Router>
        <div className="container-fluid ">
          <Switch>
            <Route exact path="/" component={Home}/>
            <PrivateRoute path="/home" component={Home}/>

            <Route component={NoMatch}/>
          </Switch>
        </div>
      </Router>
    );
  }
}


const NoMatch = ({ location }) => (
  <div className="row justify-content-center">
    <div className="col-sm-6 col-md-6">
      <h2 className="text-danger">Ooops...</h2>
      <h4>
        A página <code>{location.pathname}</code> não existe.
      </h4>
      Volte para <Link to="/home">o início.</Link>
    </div>
  </div>
);

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isLoggedIn() ? (
        <Component token={getAccessToken()} {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/",
            state: { from: props.location }
          }}
        />
      )
    }
  />
);

export default App;
